import { render, staticRenderFns } from "./leftCard.vue?vue&type=template&id=8e08b734&scoped=true&"
import script from "./leftCard.vue?vue&type=script&lang=js&"
export * from "./leftCard.vue?vue&type=script&lang=js&"
import style0 from "./leftCard.vue?vue&type=style&index=0&id=8e08b734&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e08b734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e08b734')) {
      api.createRecord('8e08b734', component.options)
    } else {
      api.reload('8e08b734', component.options)
    }
    module.hot.accept("./leftCard.vue?vue&type=template&id=8e08b734&scoped=true&", function () {
      api.rerender('8e08b734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/leftCard.vue"
export default component.exports